import React, { useEffect, useRef } from "react";


const Pastor = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Function to set up the pause once metadata is loaded
    const handleLoadedMetadata = () => {
      const pauseTime = video.duration / 2;

      const handleTimeUpdate = () => {
        if (video.currentTime >= pauseTime && !video.paused) {
          video.pause();
        }
      };

      video.addEventListener("timeupdate", handleTimeUpdate);

      // Cleanup
      return () => {
        video.removeEventListener("timeupdate", handleTimeUpdate);
      };
    };

    video.addEventListener("loadedmetadata", handleLoadedMetadata);

    return () => {
      video.removeEventListener("loadedmetadata", handleLoadedMetadata);
    };
  }, []);

  return (
    <>
      {/* ================= GIVE HERO ================= */}
      <section className="give-hero">
        <video
          className="give-video"
          src="/images/v2.mp4"
          controls
          preload="metadata"
          ref={videoRef}
        />

        <div className="give-hero-overlay">
          <h1>Give</h1>
          <p>Partner with us in advancing God’s Kingdom</p>
        </div>
      </section>

      {/* ================= TEACHING + IMAGES ================= */}
      <section className="container my-5">
        <div className="row align-items-center g-5">
          {/* LEFT CONTENT */}
          <div className="col-md-6">
            <h2 className="give-title">Teaching on Giving</h2>
            <p className="give-text">
              Giving is one of the instructions that God gave me from heaven to come and teach His people. 
              When you give back to God, 1. You are honoring God. 2. You are welcoming God to be part of your finances, 
              material possession, job, business or sources of income. God is very generous, a good giver.
            </p>
            <p className="give-text">
              He created the entire earth, put everything in it and gave it all to man without 
              demanding anything in exchange or putting commands on man how to use it.
            </p>
            <p className="give-text">
              Likewise, those who belong to God ought to have the same heart and character of their creator by 
              freely giving back to Him with love. The following are ways through which you can give.
              <strong> “Tithe. Offering, First giving. Thanks giving. Love giving and the rest as God leads you.”</strong>
            </p>
          </div>

          {/* RIGHT IMAGES */}
          <div className="col-md-6">
            <div className="give-images">
              <img src="/images/pastor5.jpg" alt="Giving" />
            </div>
          </div>
        </div>
      </section>

      {/* ================= GIVE FORM ================= */}
      <section className="give-form-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-7">
              <div className="give-form-card">
                <h4 className="text-center mb-4">Give Your Offering</h4>

                <form>
                  <div className="mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your name"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Giving Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter amount"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Giving Type</label>
                    <select className="form-select">
                      <option>Offering</option>
                      <option>Tithe</option>
                      <option>Seed</option>
                      <option>Donation</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Message (Optional)</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Leave a message or prayer request"
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary w-100">
                    Proceed to Give
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= INTERNAL CSS ================= */}
      <style>{`
        /* HERO */
        .give-hero {
          position: relative;
          width: 100%;
          height: 70vh;
          overflow: hidden;
          background: #000;
        }
        
        .give-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .give-hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.45);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          color: #ffffff;
          padding: 20px;
        }
        
        .give-hero-overlay h1 {
          font-size: 56px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        
        .give-hero-overlay p {
          font-size: 18px;
          max-width: 600px;
        }

        /* TEACHING */
        .give-title {
          font-weight: 700;
          color: #0b1c6b;
          margin-bottom: 15px;
        }

        .give-images {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        .give-images img {
          width: 200%;
          height: 600px;
          max-width: 500px;
          object-fit: cover;
          border-radius: 5px;
        }

        .give-text {
          font-size: 18px;
        }

        /* FORM */
        .give-form-section {
          background: #f8f9fa;
        }

        .give-form-card {
          background: #fff;
          padding: 35px;
          border-radius: 14px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
        }

        @media (max-width: 768px) {
          .give-hero-overlay h1 {
            font-size: 2rem;
          }

          .give-images {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
};

export default Pastor;
